import { of } from 'rxjs/observable/of'
import q from 'querystring'
import { tokenService } from '@app/auth/tokenService'

import {
  setData,
  setErrors,
  TOKEN_PRESENT_ON_MOUNT,
} from '../../common/utils/resource'

export default function processToken(action$, store, { API }) {
  return action$.ofType(TOKEN_PRESENT_ON_MOUNT).mergeMap(action => {
    // Prefer token from URL.
    const token = q.parse(window.location.search)['?token'] || action.token
    const valid = tokenService.isTokenValid(token)
    if (!valid) {
      return of(setErrors('Invalid token', { resource: { namespace: 'session' } }))
    }

    // Store token so that fetching user has correct token (in case it was on URL).
    tokenService.setToken(token)
    // valid token, set it on store which will trigger getting user
    return of(setData({ token }, { resource: { namespace: 'session' } }))
  })
}
